import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { DatePicker } from 'primeng/datepicker'
import { IftaLabel } from 'primeng/iftalabel'
import { AlbertBaseControlDirective } from '@directives/albert-base-control.directive'

@Component({
  selector: 'albert-datepicker',
  standalone: true,
  imports: [ReactiveFormsModule, DatePicker, IftaLabel],
  templateUrl: './albert-datepicker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertDatepickerComponent extends AlbertBaseControlDirective {}
